import { render, staticRenderFns } from "./CustomizableForm.vue?vue&type=template&id=9939ddbc&scoped=true&name=customizable-form&"
import script from "./CustomizableForm.vue?vue&type=script&lang=js&"
export * from "./CustomizableForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomizableForm.vue?vue&type=style&index=0&id=9939ddbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9939ddbc",
  null
  
)

export default component.exports